/// <reference types="vite/client" />

/** A locale file as `import.meta.glob` loads it: the YAML's messages as default export. */
export type LocaleModule = { default: Record<string, unknown> };

/**
 * The library's locale files (`./locales/*.yaml`), globbed relative to this module.
 *
 * Apps pass this to astro-core's `createI18nFactory` instead of globbing
 * `@pixelpoint-pattern-library-v2-core/base/i18n/locales/*.yaml` themselves: a glob through that
 * tsconfig `paths` alias only follows the alias's first target (`../packages/…`), so it finds
 * nothing in a workspace that keeps its app one level deeper (`apps/<name>/`). A relative glob in
 * the package itself works at any depth.
 */
export const baseLocales: Record<string, () => Promise<LocaleModule>> = import.meta.glob<LocaleModule>(
  "./locales/*.yaml",
);
